// extracted by mini-css-extract-plugin
export var addToCartButton = "_ua-b";
export var arrowButtonContainer = "_ua-9";
export var arrowButtonIcon = "_ua-a";
export var carouselArrowButton = "_ua-6";
export var carouselElementContainer = "_ua-1";
export var left = "_ua-7";
export var productDisplayCarouselContainer = "_ua-0";
export var productTileContainer = "_ua-2";
export var productTileImage = "_ua-4";
export var productTileImageContainer = "_ua-3";
export var productTileTitle = "_ua-5";
export var right = "_ua-8";
export var sliderOverflow = "_ua-c";